<template>
  <div :class="['radio-block', { error: error }]">
    <div :class="['radio-field', name]">
      <radio-base
        :name="name"
        value="Mr"
        :is-checked="isChecked('Mr')"
        :label="misterLabel || $t('reusable.male')"
        @change="updateTitle('Mr')"
      />
      <radio-base
        :name="name"
        value="Ms"
        :is-checked="isChecked('Ms')"
        :label="missLabel || $t('reusable.female')"
        @change="updateTitle('Ms')"
      />
    </div>
    <errors
      v-if="error"
      :errors="[errorMsg]"
    />
  </div>
</template>

<script>
  import RadioBase from 'components/Elements/Base/Radio'
  export default {
    name: 'Title',
    components: {
      RadioBase,
      Errors: () =>
        import(/* webpackChunkName: "element-errors" */ 'components/Elements/Errors')
    },
    props: {
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      name: {
        type: String,
        required: true
      },
      value: {
        type: String,
        required: true
      },
      labels: {
        type: Array,
        default: () => []
      },
      error: {
        type: Boolean,
        default: false
      },
      errorMsg: {
        type: String,
        default: '',
        required: false
      }
    },
    data() {
      return {
        missLabel: '',
        misterLabel: ''
      }
    },
    mounted() {
      if (!this.labels.length) {
        return
      }

      const [mr, ms] = this.labels

      this.missLabel = ms
      this.misterLabel = mr
    },
    methods: {
      updateTitle(value) {
        this.$emit('updateTitle', value)
      },
      isChecked(value) {
        return this.value === value
      }
    }
  }
</script>

<style
  lang="scss"
  scoped
  rel="stylesheet/scss"
>
  @import '~assets/styles/common.scss';

  .error {
    /deep/ label {
      span {
        border-color: $red-dark !important;
      }
    }
  }

  .radio-field {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 16px;

    @include bp-mf-tablet {
      max-width: 276px;
      margin-bottom: 12px;
    }

    /deep/ label {
      width: calc(50% - 8px);

      &:hover,
      &:focus {
        outline: none;

        span {
          cursor: pointer;
          background-color: $blue-white;
          border-color: $blue-medium;
          color: $blue-medium;
        }
      }

      span {
        display: block;
        text-align: center;
        color: $blue-dark;
        font-size: em(16);
        letter-spacing: 0;
        line-height: 54px;
        background: white;
        border-radius: 4px;
        box-sizing: border-box;
        border: 1px solid $blue-border;
        width: 100%;

        &:focus {
          outline: none;
        }
      }

      input[type='radio'] {
        display: none;

        &:checked + span {
          position: relative;
          background-color: $blue-white;
          border-color: $blue-medium;
          color: $blue-medium;
        }
      }
    }
  }
</style>
